<template>
  <card
    dis-hover
    :padding="8"
    :class="`pc-item ${single ? 'single' : 'list-item'}`"
    @click.native="openPayment"
  >
    <div class="pc-item-content">
      <div class="pc-item-info">
        <div class="pc-item-date ms-subhead">
          Платеж от {{ payment.date ? formatDefaultDate(payment.date) : '–' }}
        </div>
      </div>
      <div class="pc-item-companies">
        <div class="pc-item-from">
          <span class="ms-help">Отправитель:</span>
          <span class="ms-text">
            {{
              payment.from_company_id
                ? payment.from_company.name
                : `ИНН: ${payment.from_company_inn ||
                    "не указан"} / КПП: ${payment.from_company_kpp ||
                    "не указан"}`
            }}
          </span>
        </div>
        <div class="pc-item-from">
          <span class="ms-help">Получатель:</span>
          <span class="ms-text">
            {{
              payment.to_company_id
                ? payment.to_company.name
                : `ИНН: ${payment.to_company_inn ||
                    "не указан"} / КПП: ${payment.to_company_kpp ||
                    "не указан"}`
            }}
          </span>
        </div>
      </div>
      <div class="pc-item-subinfo">
        <div class="pc-item-costs">
          <span class="ms-help">Сумма:</span>
          <tag color="primary" class="ms-costs">
            {{ getFormattedCosts(payment.costs, true) }} руб.
          </tag>
        </div>
        <div class="pc-item-costs">
          <span class="ms-help">Распределено:</span>
          <tag :color="payment.distributed_costs ? 'green' : 'red'">
            {{ getFormattedCosts(payment.distributed_costs, true) }} руб.
          </tag>
        </div>
      </div>
    </div>
    <div class="pc-item-footer">
      <div class="pc-item-show-btn" v-if="!single">
        <button class="ms-help" @click="toggleDetails(payment, $event)">
          <icon
            :type="payment.showDetails ? 'ios-arrow-up' : 'ios-arrow-down'"
          />
        </button>
      </div>
      <div class="pc-item-details" v-show="payment.showDetails">
        <div class="pc-item-details-row ms-help">
          <span class="ms-help">Описание:</span>
          <span class="ms-text">
            {{ payment.payment_appointment || "Отсутствует" }}
          </span>
        </div>
        <div class="pc-item-details-row ms-help">
          <span class="ms-help">Комментарий:</span>
          <span class="ms-text">
            {{ payment.comment || "Отсутствует" }}
          </span>
        </div>
        <div class="pc-item-details-row ms-help">
          <span class="ms-help">Номер документа:</span>
          <span class="ms-text">
            {{ payment.input_doc_number || "Отсутствует" }}
          </span>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import { getFormattedCosts, formatDefaultDate } from '@/utils'

export default {
  props: {
    payment: {
      type: Object,
      required: true
    },
    single: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openPayment () {
      if (this.single) return

      const value = {
        ...this.payment,
        showDetails: true
      }

      this.$store.commit('TOGGLE_PC_PROP', {
        field: 'activePayment',
        value
      })
    },
    toggleDetails (payment, e) {
      if (this.single) return
      e.stopPropagation()
      payment.showDetails = !payment.showDetails
    },
    getFormattedCosts,
    formatDefaultDate
  }
}
</script>

<style lang="less">
.pc-item {
  cursor: pointer;

  &:not(:first-child) {
    margin-top: 8px;
  }

  &.list-item:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  &.single {
    .pc-item-footer {
      margin-top: 12px;
    }
  }

  &-content {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &-companies {
    width: 40%;
    margin-right: 16px;
    margin-left: auto;
  }

  &-subinfo {
    width: 35%;
  }

  &-costs {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-top: 4px;
    }

    .ivu-tag {
      width: 100%;
      text-align: center;
      margin: 0;
    }

    .ms-help {
      width: 160px;
    }
  }

  &-footer {
    margin-top: 4px;
  }

  &-show-btn {
    button {
      width: 100%;
      cursor: pointer;
      padding: 0;
      background: transparent;
      border: none;
      outline: none;
      border-radius: 4px;

      &:hover {
        background: rgba(@primary-color, 0.1);
      }
    }
  }

  &-details {
    padding: 8px 12px;
    margin-top: 4px;
    border-radius: 4px;

    &-row {
      &:not(:first-child) {
        margin-top: 4px;
      }
    }
  }
}

.light {
  .pc-item-details {
    background-color: rgba(232, 234, 236, 0.25);
  }
}

.dark {
  .pc-item-details {
    background-color: rgba(@dt-dark-bg, 0.7);
  }
}
</style>
